// extracted by mini-css-extract-plugin
export default {"sentBody":"Sent_sentBody__FcwW4"};